import { UntypedFormControl, ValidatorFn } from "@angular/forms";

/**
 * A conditional validator generator.
 * Assigns a validator to the form control if the predicate function returns true on the moment of validation
 * @param predicate predicate function
 * @param validator validator to be assign
 */
function conditionalValidator(predicate: Function, validator: ValidatorFn): ValidatorFn | null {
  return ((formControl: UntypedFormControl) => {
    if (!formControl.parent) {
      return null;
    }
    return predicate() ? validator(formControl) : null;
  })
}

export default conditionalValidator;
